import { useFormContext } from "react-hook-form";
import { format } from "date-fns";
import { DAY_MONTH_YEAR_FORMAT } from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import { coupon_code_input_field_name } from "../../CouponCodeFormGroup.constants";

export const useCoupon = (props: {
    code: string;
    couponType: number;
    onApplyCouponCodeClick: ({
        couponType,
        code,
    }: {
        couponType?: number | undefined;
        code?: string | undefined;
    }) => void;
}) => {
    const { code, couponType, onApplyCouponCodeClick } = props;

    const { setValue } = useFormContext();

    const onApplyButtonClick = () => {
        onApplyCouponCodeClick({ couponType, code });
        setValue(coupon_code_input_field_name, code);
    };

    function getCouponCodeDate(dateString: string) {
        const date = new Date(dateString);
        const formattedDate = format(date, DAY_MONTH_YEAR_FORMAT);
        return formattedDate;
    }

    return {
        onApplyButtonClick,
        getCouponCodeDate,
    };
};
